export default __webpack_public_path__ + "static/media/invaders.2b638b7e.ttf";